<template>
  <canvas :height="height" :width="width" id="financements-engages-travaux"></canvas>
</template>
<script>
import {SOLUTIA} from "@/constants/Colors";
import {Chart} from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
  name: "FinancementsEngagesTravaux",
  props: {
    data: Array,
    height: {
      type: Number,
      default: 600,
    },
    width: {
      type: Number,
      default: 600,
    }
  },
  mounted: async function () {
    let statusFetchStatus = this.$store.getters["dossier/statuts/statut_fetch_status"];
    if (statusFetchStatus === "INITIAL" || statusFetchStatus === "ERROR") {
      await this.$store.dispatch("dossier/statuts/getStatuts");
    }
    // eslint-disable-next-line no-unused-vars
    const chartData = {
      label: "Financements engagées des travaux",
      labels: this.data.map(data_of_year => data_of_year.year),
      datasets: [
          {
          label: "Travaux et MOE engagés",
          data: this.data.map(data_of_year => Math.round(data_of_year.travaux_moe_engagees / 1000)),
          datalabels: {
            color: '#ffffff',
            font: {
              size: 16
            }
          },
          backgroundColor: SOLUTIA[0]
        },
        {
          label: "Travaux MOE payés",
          data: this.data.map(data_of_year => Math.round(data_of_year.travaux_moe_payees / 1000)),
          datalabels: {
            color: '#ffffff',
            font: {
              size: 16
            }
          },
          backgroundColor: SOLUTIA[1]
        }
      ],
    }
    // eslint-disable-next-line no-unused-vars
    const config = {
      title: {
        display: true,
        text: "Travaux et MOE engagés",
        fontSize: 16,
      },
      legend: {
        display: false,
      },
      scales: {
        yAxes: [{
          stacked: false,
          ticks: {
            beginAtZero: true
          },
          gridLines: {
            drawBorder: false,
          }
        }],
        xAxes: [{
          stacked: false,
          gridLines: {
            display: false,
          }
        }]
      },

    }
    let that = this;
    this.$nextTick(function () {
      const ctx = document.getElementById('financements-engages-travaux');
      console.log(chartData);
      that.chart = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: "bar",
        //...defaultData
        data: chartData,
        options: config,
      });
    })
  },
  data: function () {
    return {
      chart: null
    }
  },
  computed: {
    statuts() {
      return this.$store.getters["dossier/statuts/statuts"];
    },
  },
  methods: {}
}
</script>

<style scoped>

</style>